/* eslint-disable */
import Slideout from "slideout";

export default {
  init() {
    // $(".advertisement-slideshow")
    //   .slick({
    //     accessibility: false,
    //     arrows: false,
    //     autoplay: true,
    //     draggable: false,
    //     pauseOnHover: false,
    //     autoplaySpeed: 7000
    //   });

    $(".js-permalink").on("click", function() {
      window.location = $(this)
        .find("a")
        .attr("href");
    });

    document
      .querySelector(".js-search-toggle")
      .addEventListener("click", function() {
        document.querySelector(".js-search").classList.toggle("hidden");
      });

    const slideout = new Slideout({
      panel: document.querySelector(".site-wrapper"),
      menu: document.querySelector(".mobile-menu"),
      padding: 256,
      tolerance: 70,
      touch: false
    });

    document
      .querySelector(".js-menu-toggle")
      .addEventListener("click", function() {
        slideout.toggle();
      });

    document.querySelectorAll(".js-banner").forEach(banner => {
      banner.addEventListener("click", e => {
        e.preventDefault();
        const { title, url } = banner.dataset;
        // ga("send", "event", "Banners", "click", title);
        window.location = url;
      });
    });
  },
  finalize() {
    // document.querySelectorAll(".js-banner").forEach(banner => {
    //   const classList = banner.classList;
    //   const { title } = banner.dataset;

    //   if (classList.contains("slick-slide")) {
    //     if (classList.contains("slick-current")) {
    //       ga("send", "event", "Banners", "shown", title, {
    //         nonInteraction: true
    //       });
    //     }
    //   } else {
    //     ga("send", "event", "Banners", "shown", title, {
    //       nonInteraction: true
    //     });
    //   }
    // });
  }
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js